var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"navigation-panel",attrs:{"fluid":""}},[_c('ul',_vm._l((_vm.getNavigation),function(item){return _c('div',{key:item.id},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'GamesList', params: { id: item.url } }}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }